<div class="newsfeed">
	<app-newsfeed-header [showNewsletterOptions]="showNewsletterOptions"></app-newsfeed-header>
	<div class="article-list">
		<div class="article" *ngFor="let article of articles">
			<app-newsfeed-article-tile [mode]="'large'" [article]="article"></app-newsfeed-article-tile>
		</div>
	</div>
</div>